/**
 * 生成需要base64自定义编码的编码表
 * @param {*} num 
 * @returns 
 */
function shuffleString(num) {
  const encodeStd = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"; // 包含大写字母、小写字母、数字和特殊字符的字符串
  let runes = Array.from(encodeStd);
  let length = runes.length;
  for (let i = 0; i < length; i++) {
      let j = (i + num) % length;
      [runes[i], runes[j]] = [runes[j], runes[i]];
  }
  return runes.join('');
}
/**
 * 正常base64编码 转换为需要的base64编码
 * @param {*} base64String 
 * @param {*} num 
 * @returns 
 */
export function customBase64ByMap(base64String, num) {
  const decodeStd = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  const _b64ch = shuffleString(num);
  const customEncodingMap = {};
  for (let i = 0; i < decodeStd.length; i++) {
    customEncodingMap[decodeStd[i]] = _b64ch[i];
  }
  function customEncodeBase64(base64String) {
    return base64String.split('').map(char => customEncodingMap[char] || char).join('');
  }
  return customEncodeBase64(base64String);
}
/**
 * 定义一个函数将二进制数据转换为 Base64 编码
 * @param {*} binaryData 
 * @param {*} num 
 * @returns 
 */
export function customBase64Encode(binaryData, num) {
  var _b64ch = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  if(num){
    _b64ch = shuffleString(num);
  }
  let base64String = "";
  for (let i = 0; i < binaryData.length; i += 3) {
      let byte1 = binaryData[i];
      let byte2 = binaryData[i + 1];
      let byte3 = binaryData[i + 2];

      let triplet = (byte1 << 16) | (byte2 << 8) | byte3;

      base64String += _b64ch.charAt((triplet >>> 18) & 63);
      base64String += _b64ch.charAt((triplet >>> 12) & 63);
      base64String += (i + 1 < binaryData.length) ? _b64ch.charAt((triplet >>> 6) & 63) : "=";
      base64String += (i + 2 < binaryData.length) ? _b64ch.charAt(triplet & 63) : "=";
  }
  return base64String;
}